import React from 'react';
import { REJECTED_COPY } from '../copy';
import { formatCheckedDate } from '../derive';
import s from '../s.module.less';

const CLOCK_ICON = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <polyline points="12 7 12 12 15.5 14" />
    </svg>
);

// 卡片请求已发出、等待患者的提示条（原型 .elig-await）。请求发出后取代 Request 按钮，
// 避免患者被要两次卡
const AwaitStrip: React.FC<{ requestedAt: string }> = ({ requestedAt }) => (
    <div className={s.awaitStrip}>
        {CLOCK_ICON}
        <span>{REJECTED_COPY.await(formatCheckedDate(requestedAt))}</span>
    </div>
);

export default AwaitStrip;
